import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FILE_EXPLORER_MODE } from '../../constants/constants';

@Component({
    selector: 'ca-dataset-item',
    templateUrl: './dataset-item.component.html',
    styleUrls: ['./dataset-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatasetItemComponent {
    @Input() name: string;
    @Input() isFolder: boolean = false;
    @Input() numberOfFiles?: number;
    @Input() numberOfInvalidFiles?: number;
    @Input() filesTableMode?: string;

    @Output() onClick = new EventEmitter<void>();

    FILE_EXPLORER_MODE = FILE_EXPLORER_MODE;
}
